import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import axios from './http/axiosConfig';
import {i18n} from '../src/i18nPlugin/index';
import VueAxios from 'vue-axios';
import "./assets/css/nucleo-icons.css";
import "./assets/css/nucleo-svg.css";
import ArgonDashboard from "./argon-dashboard";
import mitt from 'mitt';

const emitter = mitt();
const app = createApp(App);
app.use(VueAxios, axios);
app.use(store);
app.use(router);
app.use(ArgonDashboard);
app.use(i18n);

app.provide('axios', app.config.globalProperties.axios);
app.config.globalProperties.emitter = emitter;

app.mount("#app");
